import { createSlice } from '@reduxjs/toolkit'

import { fetchUser } from 'redux/thunks/User'
import { IUserProps } from 'types/User'

const initialState: IUserProps = {
  user: {
    roleName: '',
    login: '',
    adminLocale: 'en',
  },
  adapter: {},
  status: {},
  fetching: false,
  doneFetching: false,
  fetchError: '',
  errors: [],
}

export const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAdapter: (state, { payload }) => {
      state.adapter = payload
    },
  },
  extraReducers: {
    [fetchUser?.pending?.toString()]: (state) => {
      state.fetching = true
    },
    [fetchUser?.fulfilled?.toString()]: (state, action) => {
      state.user = action.payload
      state.fetching = false
      state.doneFetching = true
    },
    [fetchUser?.rejected?.toString()]: (state, action) => {
      state.fetchError = action.payload
      state.fetching = false
      state.doneFetching = false
    },
  },
})

export const { setAdapter } = user.actions

export default user.reducer
